import React from "react";
import {
  Box,
  Typography,
  useTheme,
  Link,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const Footer = ({ onToggleTheme, isDarkTheme }) => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${theme.palette.divider}`,
        py: 2,
        px: 3,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Box
        sx={{
          maxWidth: 1400,
          margin: "0 auto",
          position: "relative",
        }}
      >
        {/* Code Joke in Top-Left */}
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            top: 0,
            left: 12,
            fontFamily: "monospace",
            color: theme.palette.text.disabled,
            display: { xs: "none", sm: "block" },
          }}
        >
          &#125;; // didn't forget the semi-colon
        </Typography>

        {/* Main Footer Text */}
        <Box sx={{ textAlign: "center", mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Aaron Hunt. All rights reserved.
          </Typography>

          {/* Terms & Privacy Links */}
          <Box sx={{ mt: 1 }}>
            <Link
              component={RouterLink}
              to="/terms"
              color="text.secondary"
              underline="hover"
              sx={{ mx: 1, fontSize: "0.875rem" }}
            >
              Terms
            </Link>
            /
            <Link
              component={RouterLink}
              to="/privacy"
              color="text.secondary"
              underline="hover"
              sx={{ mx: 1, fontSize: "0.875rem" }}
            >
              Privacy
            </Link>
          </Box>

          {/* Theme Toggle */}
          <Box sx={{ mt: 1 }}>
            <Tooltip title={`Switch to ${isDarkTheme ? "light" : "dark"} mode`}>
              <IconButton onClick={onToggleTheme} color="inherit">
                {isDarkTheme ? <Brightness7 /> : <Brightness4 />}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
